<rt-group
  [class.editable]="editable"
  [class.horizontal]="direction === 'horizontal'"
  [class.vertical]="direction === 'vertical'"
>
  @if (editable) {
    <rt-add-new-button
      variant="rounded"
      class="action more"
      [rtcAnalyticsTrack]="analyticsEvent ? analyticsEvent : undefined"
      (click)="onAddClick()"
      iconName="add-circle-outline"
      shape="round"
      size="medium"
      margin-right-small-xx
    >
    </rt-add-new-button>
  }
  @if (admins.length > 0) {
    <rt-group
      [class.stacked]="stacked"
      [class.horizontal]="direction === 'horizontal'"
      [class.vertical]="direction === 'vertical'"
      [class.wrap]="multiline"
      [class.grid-vertical-margin]="multiline"
      [ngClass]="'spacing--' + spacing"
      (click)="onAvatarsClick(); stopPropagation($event); $event.preventDefault()"
      class="avatars keep-radius"
    >
      @if (!isRole) {
        @for (admin of visibleAssignments(); track trackByAdmin($index, admin)) {
          <rt-avatar
            [rtTooltip]="
              renderAdminTooltip ? renderAdminTooltip(admin) : defaultAdminTooltip(admin)
            "
            [rtTooltipPosition]="tooltipPosition"
            [rtTooltipMaxWidth]="tooltipMaxWidth"
            [rtTooltipWordWrap]="tooltipWordWrap"
            [rtTooltipEnabled]="tooltipsEnabled"
            [type]="
              admin.anonymizedAt
                ? 'icon'
                : admin.hasAvatar || !admin.initials
                  ? 'image'
                  : 'initials'
            "
            [size]="avatarSize ? avatarSize : 'base'"
            [shape]="avatarShape ? avatarShape : 'oval'"
            [imageSrc]="admin.photoThumbUrl"
            [isOnline]="admin.isOnline!"
            [initials]="admin.initials"
            iconName="person"
            context="admin"
          >
          </rt-avatar>
        }
      }

      @if (isRole) {
        @for (admin of visibleAssignments(); track trackByAdmin($index, admin)) {
          <rt-avatar
            [rtTooltip]="$any(admin).name"
            [rtTooltipPosition]="tooltipPosition"
            [rtTooltipMaxWidth]="tooltipMaxWidth"
            [rtTooltipWordWrap]="tooltipWordWrap"
            [rtTooltipEnabled]="tooltipsEnabled"
            [type]="'initials'"
            [size]="avatarSize ? avatarSize : 'base'"
            [shape]="avatarShape ? avatarShape : 'oval'"
            [fullName]="$any(admin).name"
            [context]="'admin'"
          >
          </rt-avatar>
        }
      }

      @if (hasMore() && !moreButtonAsCounter) {
        <rt-icon-button
          [size]="iconButtonSize"
          [iconSize]="iconButtonSize"
          shape="round"
          variant="tertiary"
          iconName="more-horiz"
          #moreButton
          class="has-more default"
          [rtTooltip]="renderOtherAdminsTooltip ? renderOtherAdminsTooltip(otherAdmins) : null"
          [rtTooltipTemplate]="renderOtherAdminsTooltip ? null : defaultHasMoreTooltipTemplate"
          [rtTooltipPosition]="tooltipPosition"
          [rtTooltipMaxWidth]="tooltipMaxWidth"
          [rtTooltipWordWrap]="tooltipWordWrap"
          [rtTooltipEnabled]="tooltipsEnabled"
          (click)="moreClick.emit()"
        >
        </rt-icon-button>
      }

      @if (hasMore() && moreButtonAsCounter) {
        <rt-avatar
          [rtTooltip]="renderOtherAdminsTooltip ? renderOtherAdminsTooltip(otherAdmins) : null"
          [rtTooltipTemplate]="renderOtherAdminsTooltip ? null : defaultHasMoreTooltipTemplate"
          [rtTooltipPosition]="tooltipPosition"
          [rtTooltipMaxWidth]="tooltipMaxWidth"
          [rtTooltipWordWrap]="tooltipWordWrap"
          [rtTooltipEnabled]="tooltipsEnabled"
          (click)="moreClick.emit()"
          [type]="'custom'"
          [avatarTpl]="counterAvatarTemplate ?? defaultCounterAvatarTemplate"
          class="custom"
        >
        </rt-avatar>
      }
    </rt-group>
  }
</rt-group>

<ng-template #defaultHasMoreTooltipTemplate>
  <div class="tooltip-list">
    @for (admin of otherAdmins; track trackByAdmin($index, admin)) {
      <div class="tooltip-list-item">
        {{ $any(admin).name?.length ? $any(admin).name : admin.firstName + ' ' + admin.lastName }}
      </div>
    }
  </div>
</ng-template>

<ng-template #defaultCounterAvatarTemplate>
  <div class="avatar-counter">+{{ otherAdmins.length }}</div>
</ng-template>
